<template>
  <div class="account tableStyle">
    
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="openDialog">新建标准</el-button>
      </el-col>
    </el-row>

    <el-row class="tableArea">
      <el-col :span="24">
        <el-table :data="tableData" class="table-border">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="优惠名称" prop="name" align="center"></el-table-column>
          <el-table-column label="充值金额" prop="price" align="center"></el-table-column>
          <el-table-column label="赠送金额" prop="present_price" align="center">
            <template slot-scope="scope">
                {{scope.row.present_price || '-'}}
            </template>
          </el-table-column>
          <el-table-column label="适用桩群" prop="is_common" align="center">
            <template slot-scope="scope">
                {{scope.row.is_common === 1 ? '全部' : scope.row.pile_info.map(item=>item.name).toString()}}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" align="center"></el-table-column>
          <el-table-column label="有效日期" prop="publish_start" align="center" width="400">
            <template slot-scope="scope">
                {{$utils.formatDate(scope.row.publish_start,'-')}} 至 {{$utils.formatDate(scope.row.publish_end,'-')}}
            </template>
          </el-table-column>          
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini" @click="goEdit(scope.row)">修改</el-button>
              <el-button type="danger" plain size="mini" @click="goDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row class="pageFoot">
      <el-col :span="24">
        <el-pagination
          layout="total, prev, pager, next, sizes"
          :page-sizes="[20,50,100,200,500,1000]"
          background
          :page-size="size"
          :total="total"
          @size-change="sizeChange"
          @current-change="changePage"
        >
        </el-pagination>
      </el-col>
    </el-row>

    <el-dialog :title="addForm.id ? '修改标准':'新建标准'" width="30%" custom-class="dialogRadius" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" close="closeDialog">

      <el-form :model="addForm" :rules="rules" ref="addForm" label-width="auto">
        <el-form-item label="名称：" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
        </el-form-item>     
        <el-form-item label="描述：" prop="desp">
          <el-input v-model="addForm.desp" placeholder="请输入描述"></el-input>
        </el-form-item>              
        <el-form-item label="充值金额：" prop="price">
          <el-input v-model="addForm.price" placeholder="请输入充值金额" type="number"></el-input>
        </el-form-item>
        <el-form-item label="赠送金额：" prop="present_price">
          <el-input v-model="addForm.present_price" type="number"></el-input>
        </el-form-item>
        <el-form-item label="是否所有桩群：" prop="is_common">
          <el-radio v-model="addForm.is_common" :label="1">是</el-radio>
          <el-radio v-model="addForm.is_common" :label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="桩群：" prop="pg_ids" v-if="addForm.is_common===0">
          <el-select v-model="addForm.pg_ids" filterable multiple clearable placeholder="请选择"  @change="handleSelectPile">
            <el-option v-for="item in pileGroupAllList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            <!-- <el-option label="全部" :value="0" :disabled="disabledAllPile"></el-option>
            <el-option v-for="item in pileGroupAllList" :key="item.id" :label="item.name" :value="item.id" :disabled="disabledGroupPile"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="有效日期：" prop="publish_start">
          <el-date-picker v-model="datetimerange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="hadnleSelectDate"></el-date-picker>
        </el-form-item>                
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      size: 20,
      page: 1,
      total: 0,

      tableData: [],

      dialogVisible: false,
      addForm:{
        name:'',
        desp:'',
        price: '',
        present_price: 0,
        is_common:0, //是否适用所有桩群， 0否，1是
        pg_ids: [], //如果is_common=0，这里传适用桩群的id， 否则传null或者不传
        publish_start:'',
        publish_end:'',
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],    
        desp: [
          {required: true, message: '请输入描述', trigger: 'blur'},
        ],              
        price: [
          {required: true, message: '请输入充值金额', trigger: 'blur'},
        ],
        present_price: [
          {required: true, message: '请输入赠送价格', trigger: 'blur'},
        ],

        is_common:[
          {required: true, message: '请选择是否所有桩群', trigger: 'change'},
        ],

        publish_start: [
          {required: true, message: '请选择时间', trigger: 'change'},
        ],
        publish_end: [
          {required: true, message: '请选择时间', trigger: 'change'},
        ],        


      },

      datetimerange:[],

      pileGroupAllList:[], //所有桩群
      disabledAllPile:false,
      disabledGroupPile:false,
      multiple:true,

    };
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
        this.getTableList();

        this.getPileGroupAllList(); //所有桩群
    },
    // 获取table
    getTableList(data){
        let params = {};
        if (data) {
            params = data;
        }
        params.page = this.page;
        params.size = this.size;
        this.$http.get(this.common.admin + "/admin/payPriceList", {
            params: params,
        }).then((res) => {
            if (res.code === 200) {
                this.total = res.data.total;
                this.tableData = res.data.list;
            } else {
                this.$message.error(res.msg);
            }
        });
    },
    
    // 打开新建弹窗
    openDialog(){
      this.dialogVisible = true;
    },

    //选择桩群
    handleSelectPile(value){
      this.$forceUpdate();

      //全部选项放select中
      // if(value.length){
      //   if(value.includes(0)){          
      //     this.disabledAllPile = false;
      //     this.disabledGroupPile = true;
      //   }else{
      //     this.disabledAllPile = true;
      //     this.disabledGroupPile = false;
      //   }
      // }else{
      //   this.disabledAllPile = false;
      //   this.disabledGroupPile = false;
      // }

    },

    //选择时间
    hadnleSelectDate(value){
      if(value.length){
        this.addForm.publish_start = value[0];
        this.addForm.publish_end = value[1];
      }else{
        this.addForm.publish_start = '';
        this.addForm.publish_end = '';
      }
    },

    // 修改套餐
    goEdit(data){
        this.$http.get(this.common.admin + '/admin/payPriceDetail', {
            params: {id: data.id}
        }).then(res => {
            if(res.code === 200){
                this.addForm = res.data;
                this.datetimerange = [res.data.publish_start*1000,res.data.publish_end*1000]; //回显时间,接口时间戳单位秒
                this.addForm.pg_ids = res.data.pile_info.map(item=>item.id); //回显桩群
                console.log(this.addForm)
                this.openDialog();
            }else{
                return this.$message.error(res.msg);
            }
        })
    },

    //删除
    goDelete(row){
        this.$confirm(`确定删除优惠：${row.name}?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$api.payPriceDelete({id:row.id}).then(res=>{
                if(res.code === 200){
                    this.$message.success('删除成功');
                    this.getTableList();
                }
            });
        }).catch(() => {
            // this.$message.info('已取消删除');
        });
    },


    // 关闭新建弹窗
    closeDialog(){
      this.dialogVisible = false;
      this.addForm = {
        name:'',
        desp:'',
        price: '',
        present_price: 0,
        is_common:0, 
        pg_ids: [], 
        publish_start:'',
        publish_end:'',
      };
      this.datetimerange = [];

      this.$nextTick(() => {
        this.$refs.addForm.clearValidate();
      });
    },
    // 确认新建套餐
    submit(){

      this.$refs.addForm.validate(v => {
        if(v === true){

            if(this.addForm.is_common === 1){
              this.addForm.pg_ids = null;
            }

            this.addForm.publish_start = (new Date(this.datetimerange[0])).getTime()/1000; //转化为秒
            this.addForm.publish_end = (new Date(this.datetimerange[1])).getTime()/1000; //转化为秒


            let url = this.addForm.id ? '/admin/payPriceEdit' : '/admin/payPriceAdd';
            this.$http.post(this.common.admin + url, this.addForm).then(res => {
                if(res.code === 200){
                    this.$message.success(this.addForm.id ? '修改成功' : '套餐新建成功');
                    this.closeDialog();
                    this.page = 1;
                    this.getTableList();
                }
            });
        }else{
          return this.$message.error('请将信息填写完整');
        }
      });
    },
    // 翻页
    changePage(page) {
      this.page = page;
      this.getTableList();
    },
    sizeChange(val){
      this.size = val;
      this.getTableList();
    },

    //获取所有桩群
    getPileGroupAllList(){
      this.$api.pileGroupAllList().then(res=>{
        if(res.code === 200){
          this.pileGroupAllList = res.data;
        }
      })
    },


  },
};
</script>
<style lang="less" scoped>
.account {
  
  .dialogRadius{
    .tipsBox{
      /deep/.el-form-item__content{
        line-height: 1;
        .tips{
          font-size: 14px;
          color: #c0c4cc;
        }
      }
    }
  }
}
</style>